import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  async updateRolePermissionResources({ id, params }) {
    try {
      const response = await axios.put(`auth/roles/${id}/updateRolePermissionResources`, { params })
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getPermissionResources({ id, params }) {
    try {
      const response = await axios.get(`auth/roles/${id}/rolePermissionResource`, { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { total, records } = data.data
        return { total, records }
      }
      return {
        total: 0,
        records: [],
      }
    } catch (e) {
      handleCatch(e)
    }
  },
}
